import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { TranslateFunction } from 'react-localize-redux';

import { Typography } from '../../atoms/Typography';
import { Dialog } from '../../layouts/Dialog';
import { LoyaltyProgressBar } from '../../molecules/LoyaltyProgressBar';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  loyaltyContainer: {
    marginBottom: theme.spacing(3),
  },
}));

export type HowLoyaltyWorksDialogProps = {
  currentStar: number;
  details: string;
  onClose: () => void;
  open: boolean;
  showPending?: boolean;
  totalStars: number;
  translate: TranslateFunction;
};

export function HowLoyaltyWorksDialog(
  props: HowLoyaltyWorksDialogProps,
): JSX.Element {
  const {
    currentStar,
    details,
    onClose,
    open,
    showPending = false,
    totalStars,
    translate,
  } = props;
  const classes = useStyles();

  return (
    <Dialog dialogName="how-loyalty-works" onTitleClick={onClose} open={open}>
      <Typography className={classes.title} variant="h1">
        {translate('LoyaltyCard_HowLoyaltyWorks')}
      </Typography>
      <div>
        <div className={classes.loyaltyContainer}>
          <Typography variant="body1">
            {translate(`LoyaltyCard_YourLoyaltyProgress`)}
          </Typography>
          <LoyaltyProgressBar
            currentStar={currentStar}
            showPendingStar={showPending}
            totalStars={totalStars}
          />
        </div>
        <Typography variant="body2">
          {translate('LoyaltyVoucherDialog_details')}
        </Typography>
        <Typography variant="body2-secondary">{details}</Typography>
      </div>
    </Dialog>
  );
}
